import { ComponentProps } from 'react';

import useOverlayStatus from '../components/OverlayStatusContext/useOverlayStatus';
import usePostNavigationToParent from '../hooks/usePostNavigationToParent';

import DefaultLayout from './DefaultLayout';
import OverlayLayout from './OverlayLayout';
import useAutoForceOverlayMode from './hooks/useAutoForceOverlayMode';

type AutoOverlayOrDefaultLayoutProps = ComponentProps<typeof OverlayLayout>;

const AutoOverlayOrDefaultLayout = ({
    children,
    title,
    ...props
}: AutoOverlayOrDefaultLayoutProps) => {
    const { inOverlay } = useOverlayStatus();

    /**
     * Keep track of all inertia navigations and post them to the parent frame.
     */
    usePostNavigationToParent({ title: title });

    /**
     * Detect backend initiated forced overlay mode
     */
    useAutoForceOverlayMode();

    return inOverlay ? (
        <OverlayLayout {...props} title={title}>
            {children}
        </OverlayLayout>
    ) : (
        <DefaultLayout {...props}>{children}</DefaultLayout>
    );
};

export default AutoOverlayOrDefaultLayout;
